import React, { useState, useEffect } from "react";
import TextBox from "../components/TextBox/TextBox"
import { Container } from "../components/Grid"
import Inventory from "../components/Inventory/Inventory"
import GameTextModal from "../components/Modals/GameTextModal";
// import World from '../features/world/index';
import Cliffs from "../components/MapLocations/Cliffs";
import Forest from "../components/MapLocations/Forest";
import Village from "../components/MapLocations/Village";
import Castle from "../components/MapLocations/Castle";
import { useParams } from "react-router-dom";
import API from "../utils/API";
import MusicBtn from "../components/SoundBtns/MusicBtn";

function Continue() {

    const { id } = useParams();
    const [userAvatar, setUserAvatar] = useState(null)
    const [userAvatarName, setUserAvatarName] = useState(null)
    const [userAvatarMoney, setUserAvatarMoney] = useState(null)
    const [place, setPlace] = useState("village")
    const [userData, setUserData] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [loadError, setLoadError] = useState("")

    useEffect(() => {

        const getUserData = async ()=> {
            const userData = await API.getUser(id)
            const user = await userData.json()

         
            setUserAvatarName(user.sprite[0].sprite)
            setPlace(user.sprite[0].place || "village")
            setUserData(user)
            setIsLoading(false)
            
        }
  

        getUserData().catch(() => {
            setLoadError("We could not load your adventure. Please refresh and try again.")
            setIsLoading(false)
        })
    }, [id]);

    if (isLoading) {
        return <div className="world-map-loading" role="status">Loading your adventure…</div>
    }

    if (loadError) {
        return <div className="world-map-loading" role="alert">{loadError}</div>
    }

    return (
        <Container fluid>
            <div>
            <MusicBtn user={userData} />
            <h1 className="text-center">World Map</h1>           

            <div className="game-board" data-place={place} aria-label="World map book">
                {/* Game Board */}
                <img className="game-board__book" src={require("../images/open-book-board.png")} alt="World Map" />
                <Cliffs />
                <Forest />
                <Village />
                <Castle />
                <div>
                    {/* Dynamically rendered game text appears in text-box */}
                    <TextBox avatar={userAvatarName} user={userData} />
                </div>
            </div>
            </div>
        </Container>
    )
}

export default Continue;